import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ProductModalProductPreviewSupplierFragmentDoc = gql`
  fragment ProductModalProductPreviewSupplier on Supplier {
    id
    name
    supplierRelationship {
      id
      preferredSupplier
    }
  }
` as unknown as DocumentNode<Types.ProductModalProductPreviewSupplierFragment, unknown>
